export default __webpack_public_path__ + "static/media/sy-dp3.0e3173b6.png";